module.exports = __webpack_public_path__ + "img/map_placeholder.cb69f01c.jpg";